module.exports = __webpack_public_path__ + "static/BrandonGrotesque-LightItalic-907246278866d09b224d6923b72a2216.woff";